
      import CheckCircleLight from './check-circle-light.vue'
      import type { App, Plugin } from 'vue'

      export const CheckCircleLightPlugin: Plugin = {
        install(app: App) {
          app.component('CheckCircleLight', CheckCircleLight)
        },
      }
      export { CheckCircleLight }
      